import { Css_HeadingH3_tw, HeadingH1 } from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockTable } from '@dreamstack/payload/src/payload-types'
import { cn } from '@dreamstack/util'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'

export const TableFinanceCalendar: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockTable
  }>
> = ({ block }) => {
  const { title, table } = block
  const tableData =
    (table as { tableData?: string[][] } | null)?.tableData ?? null
  const rowData: string[][] = tail(tableData) || [[]]
  return (
    <div className="w-full mt-px-48 md:mt-px-80">
      {title && <HeadingH1 className="mb-px-48">{title}</HeadingH1>}
      <div className="w-full overflow-auto">
        <table className="w-full">
          <thead>
            <tr>
              <th className="md:w-[246px]"></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {map(rowData, (rowEntry, i) => {
              const length = rowEntry.length
              const firstTd = length > 0 ? rowEntry[0] : ''
              const secondTd = length > 1 ? rowEntry[1] : ''
              return (
                <tr key={i}>
                  <td
                    className="py-px-32 align-top text-px-16 leading-px-30 ml:text-px-20 ml:leading-px-42"
                    dangerouslySetInnerHTML={{ __html: firstTd }}
                  />
                  <td
                    className={cn(
                      `py-px-32 align-top pl-px-12 md:pl-px-48 lg:pl-px-64`,
                      Css_HeadingH3_tw
                    )}
                    dangerouslySetInnerHTML={{ __html: secondTd }}
                  />
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
